const React = require('react');
export default class Modal extends React.Component {
    constructor(props) {
        super(props);
        this.cancel = this.cancel.bind(this)
        this.confirm  = this.confirm.bind(this)
    }

    static defaultProps ={
        confirmBtn:'确定',
        cancelBtn:'取消',
        hasConfirm: true,
    };

    cancel(){
        this.props.onCancel && this.props.onCancel()
    }

    confirm(){
        this.props.onConfirm && this.props.onConfirm()
    }

    render() {
        const {
            title,
            content,
            confirmBtn,
            cancelBtn,
            hasConfirm,
            hasKnown,
            tipsAlign,
            origin
        } = this.props;
        if(origin==='cancelAppoint'){
            return (
                <div className = "modal-wrapper" onClick={this.cancel}>
                    <div className = "modal" onClick={(e)=>e.stopPropagation()}>
                        <div className = "title"> {title}</div>
                        {this.props.children}
                        <div className="btn-container dflex alignCenter packFlow ">
                            <span className="input-button middle cancel" onClick = {this.cancel}><span>{cancelBtn}</span></span>
                            <span className="input-button middle confirm " onClick = {this.confirm}>{confirmBtn}</span>
                        </div>
                    </div>
                </div>
            )
        }
        if(origin==='studentRecord'){
            return (
                <div className = "modal-wrapper" >
                    <div className = "modal" onClick={(e)=>e.stopPropagation()}>
                        {this.props.children}
                        <div className="btn-container dflex alignCenter packFlow ">
                            <span className="input-button middle confirm " onClick = {this.confirm} style={{width:'100%'}}>{confirmBtn}</span>
                        </div>
                    </div>
                </div>
            )
        }
        if(origin==='xkCoach'){
            return (
                <div className = "modal-wrapper" onClick={this.cancel}>
                    <div className = "modal2" onClick={(e)=>e.stopPropagation()}>
                        {this.props.children}
                    </div>
                </div>
            )
        }
        if(origin==='xkCoachBottom'){
            return (
                <div className = "modal-wrapper" onClick={this.cancel}>
                    <div className = "modal3" onClick={(e)=>e.stopPropagation()}>
                        {this.props.children}
                    </div>
                </div>
            )
        }
        else{
            return (
                <div className = "modal-wrapper" onClick={this.cancel}>
                    <div className = "modal" onClick={(e)=>e.stopPropagation()}>
                        {title && <div className = "title"> {title}</div>}
                        <div
                            className = "tip"
                            style={ tipsAlign ? {textAlign:tipsAlign}:{}}
                            dangerouslySetInnerHTML={{__html:content}}
                        />
                        {
                            origin==='madsa'?
                                <div className="btn-container dflex alignCenter packFlow "
                                     style={{justifyContent: 'center'} }
                                >
                                    <span className="input-button middle confirm " onClick = {this.confirm}>去完成</span>
                                </div>
                                :
                                <div className="btn-container dflex alignCenter packFlow "
                                     style={!!hasConfirm ? {} : {justifyContent: 'center'}}
                                >
                                    {!!hasConfirm && <span className="input-button middle cancel" onClick = {this.cancel}><span>{cancelBtn}</span></span>}
                                    {!!hasConfirm && <span className="input-button middle confirm " onClick = {this.confirm}>{confirmBtn}</span>}
                                    {!!hasKnown && <span className="input-button middle confirm " onClick = {this.cancel} style={{width:'160px'}}>知道了</span>}
                                </div>
                        }
                    </div>
                </div>
            )
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/component/modal.js